import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  Typography,
  Backdrop,
  CircularProgress,
  TablePagination,
  Box,
  Tooltip,
  Card,
  List,
  CardActions,
  CardContent,
} from "@material-ui/core";
import CardHeader from "@material-ui/core/CardMedia";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import useStyles from "../../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import "react-datepicker/dist/react-datepicker.css";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import "../../../../css/employee-page.css";
import { useNotification } from "../../../../hooks/useNotification.js";
import MUIDataTable from "mui-datatables";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import CloseIcon from "@material-ui/icons/Close";

export default function ApproveLeaveList() {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const mobileQuery = useMediaQuery("(max-width:600px)");

  const [loader, setLoader] = useState(false);
  const [viewLeaveData, setViewLeaveData] = useState([]);
  const [viewLeaveDetails, setViewLeaveDetails] = useState({});

  const [state, setState] = useState({
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  useEffect(() => {
    fetchLeaveData();
  }, []);

  function displayLeaveDates(values) {
    if (!values) return [];
    const leaveArray = JSON.parse(values);
    console.log(leaveArray);
    return leaveArray;
  }

  const fetchLeaveData = async () => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}leave/viewAllLeaveRequests?page=${currerntPage}&status=APPROVED`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setViewLeaveData(response.data.data);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrerntPage(newPage + 1);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}leave/viewAllLeaveRequests?page=${currerntPage}&status=APPROVED`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setViewLeaveData(response.data.data);
        setCount(response.data.count);
      }
      setLoader(false);
    });
  };

  function capitalizeFirstLetter(string) {
    return string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase();
  }

  function getEmpName(user) {
    let empName;
    if (user?.employee) {
      empName = user.employee?.firstName + " " + user.employee?.lastName;
    }

    if (user?.recruiter) {
      empName = user.recruiter?.firstName + " " + user.recruiter?.lastName;
    }
    return empName;
  }

  const HeaderElements = () => <>Total : {count}</>;

  function ViewLeaveDetails(item) {
    setViewLeaveDetails(item);
    toggleDrawer("right", true)();
  }

  console.log(viewLeaveDetails);

  const list = (anchor) => (
    <>
      <Box sx={{ width: "100%", padding: "0 20px" }} role="presentation">
        <List>
          <Card className={classes.root} px={3}>
            <CardHeader>
              <Grid
                container
                direction="row"
                spacing={1}
                className={classes.drawerHeader}
              >
                <Typography variant="subtitle1">Leave Details</Typography>

                <Grid className={classes.drawerClose}>
                  <CloseIcon
                    className={classes.closeBtn}
                    size="14px"
                    onClick={toggleDrawer(anchor, false)}
                  />
                </Grid>
              </Grid>
            </CardHeader>
            <CardContent className={classes.drawerViewContent}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Name:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {getEmpName(viewLeaveDetails?.requestedUser)}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Role Type:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {capitalizeFirstLetter(
                    viewLeaveDetails?.requestedUser?.roleName,
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Leave Type:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <div style={{ textTransform: "capitalize" }}>
                    {viewLeaveDetails?.leaveType === "PERSONAL"
                      ? "Privilege Leave"
                      : capitalizeFirstLetter(viewLeaveDetails?.leaveType)}
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Duration:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {viewLeaveDetails?.value > 1
                    ? viewLeaveDetails?.value + " days"
                    : viewLeaveDetails?.value + " day"}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Leave Date:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {moment(viewLeaveDetails?.fromDate).format("DD-MM-YYYY") +" - "+ moment(viewLeaveDetails?.toDate).format("DD-MM-YYYY")}
                </Grid>

             
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Posted Date:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {moment(viewLeaveDetails?.createdAt).format("DD-MM-YYYY")}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Status:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography style={{ color: "green" }}>
                    {viewLeaveDetails?.status}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Approved Date:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {moment(viewLeaveDetails?.createdAt).format("DD-MM-YYYY")}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    {" "}
                    Reason:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    minHeight: "100px",
                  }}
                >
                  {" "}
                  {viewLeaveDetails?.reason}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    {" "}
                    List of Leave:{" "}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                </Grid>

                <Grid item xs={12}>
                  {" "}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                    }}
                    border="1"
                  >
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Leave Type</th>
                        <th>Day</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayLeaveDates(viewLeaveDetails?.leaveDates).map(
                        (item, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: "center", padding: "5px" }}>
                              {moment(item?.date).format("DD-MM-YYYY")}
                            </td>
                            <td style={{ textAlign: "center", padding: "5px" }}>
                              {item?.leaveType}
                            </td>
                            <td style={{ textAlign: "center", padding: "5px" }}>
                              {item?.value}
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              <Grid
                container
                direction="row"
                spacing={2}
                className={classes.drawerFooter}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={toggleDrawer(anchor, false)}
                >
                  Close
                </Button>
              </Grid>
            </CardActions>
          </Card>
        </List>
      </Box>
    </>
  );

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container spacing={2}></Grid>

      <Grid item xs={12}>
        <MUIDataTable
          title=""
          options={{
            textLabels: {
              body: {
                noMatch: "Oops! Matching record could not be found",
              },
            },
            pagination: false,
            sort: false,
            selectableRows: "none",
            search: false,
            filter: false,
            download: false,
            print: false,
            customToolbar: () => <HeaderElements />,
            responsive: mobileQuery === true ? "vertical" : "standard",
          }}
          columns={[
            {
              name: "S.No",
            },
            {
              name: "Employee Name",
            },
            {
              name: "Reason",
            },
            {
              name: "Duration",
            },
            {
              name: "Leave Date",
            },
            {
              name: "Posted Date",
            },
            {
              name: "Approved Date",
            },
            {
              name: "Action",
            },
          ]}
          data={viewLeaveData.map((item, index) => {
            return [
              <>
                {currerntPage !== 0
                  ? 10 * currerntPage - 10 + index + 1
                  : index + 1}
              </>,
              getEmpName(item.requestedUser),
              <div
              key={index}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "200px",
                  whiteSpace: "nowrap",
                }}
              >
                {item.reason}
              </div>,
              item?.value > 1 ? item?.value + " days" : item?.value + " day",
              moment(item.fromDate).format("DD-MM-YYYY") +" - "+ moment(item.toDate).format("DD-MM-YYYY"),
              
              moment(item.createdAt).format("DD-MM-YYYY"),
              moment(item.updatedAt).format("DD-MM-YYYY"),
              <>
                <Tooltip title="View JD" placement="bottom" aria-label="view">
                  <RemoveRedEyeIcon
                    className={classes.toolIcon}
                    onClick={() => ViewLeaveDetails(item)}
                  />
                </Tooltip>
              </>,
            ];
          })}
        />

        <Grid container spacing={2} className={classes.pagination}>
          <TablePagination
            rowsPerPageOptions={[50]}
            component="div"
            count={count}
            rowsPerPage={10}
            page={page}
            onPageChange={handleChangePage}
          />
        </Grid>
      </Grid>

      <SwipeableDrawer
        anchor="right"
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
        classes={{ paper: classes.drawer }}
      >
        {list("right")}
      </SwipeableDrawer>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
